import { observable } from 'mobx'
import moment from "moment";

export default class NovoDirecionamentoStore {

    @observable tipoDoc;
    @observable flagCarga;
    @observable ceHouse;
    @observable container;
    @observable cnpj;
    @observable razaoSocial
    @observable operacao;
    @observable dtAtracacaoInicio;
    @observable dtAtracacaoFim;
    @observable operacoes;
    @observable loadingOperacoes

    @observable adicionar;
    @observable loadingImport;
    @observable listaImportacao;
    @observable listaAnexos;
    @observable aviso
    
    constructor(service) {

        this.tipoDoc = "DTC"
        this.flagCarga = false
        this.ceHouse = ""
        this.container = ""
        this.cnpj = ""
        this.razaoSocial = ""

        this.operacao = null
        this.dtAtracacaoInicio = moment().add(-10, 'day').format("YYYY-MM-DD")
        this.dtAtracacaoFim = moment().add(30, 'day').format("YYYY-MM-DD")
        
        this.adicionar = false
        this.loadingImport = false
        this.loadingOperacoes = false
        
        this.listaImportacao = []
        this.listaAnexos = []
        this.operacoes = []

        this.aviso = ""

        this.service = service

        this.listarOperacoes();
    }

    listarOperacoes = () => {
        this.loadingOperacoes = true
        this.service.Operacoes(this.dtAtracacaoInicio, this.dtAtracacaoFim, this.tipoDoc).then(response => {
            if(response && response.data && response.data.length > 0){
                this.operacoes = response.data.map(op => ({label: op.NavioViagem + " - " + moment(op.DtPrevAtrac).format("DD/MM/YYYY"), value: op.VesselVisit}))
            } else {
                this.operacoes = [];
            }
        }).catch(err => console.log(err)
        ).finally(() => this.loadingOperacoes = false)
    }

    setDadosDirecionamento = (direc) => {
        this.operacao = direc.operacao
        this.dtAtracacaoInicio = direc.dtInicial
        this.dtAtracacaoFim = direc. dtFim
        this.tipoDoc = direc.tipoDoc
    }

    setDataInicio = (value) => {
        this.dtAtracacaoInicio = value
    }
    
    setDataFim = (value) => {
        this.dtAtracacaoFim = value
    }

    setDadosEdicao = (row) => {
        this.ceHouse = row.CeHouse
        this.container = row.Container
        this.cnpj = row.Cnpj
        this.razaoSocial = row.RazaoSocial
        row.Anexo ? this.listaAnexos.push(row.Anexo) : this.listaAnexos = []
    }

    setTipoDoc = (event) => {
        if (event.target.value === "DTA")
        {
            this.tipoDoc = "DTA"
            this.setFlagCarga(this.flagCarga);
        }
        else if (event.target.value === "DTC")
        {
            this.tipoDoc = "DTC"
            this.setFlagCarga(false);
        }
        
        if(this.dtAtracacaoInicio !== null && this.dtAtracacaoFim !== null) {
            this.listarOperacoes()
        }
    }

    setFlagCarga = (value) => {
        this.flagCarga = value
    }
    
    setCeHouse = (value) => {
        this.ceHouse = value
    }

    setContainer = (value) => {
        this.container = value
    }
    
    setCnpj = (value) => {
        this.cnpj = value
    }
    
    setRazaoSocial = (value) => {
        this.razaoSocial = value
    }

    setOperacao = (event) => {
        this.operacao = event
    }

    anexarArquivo = (event) => {
        this.listaAnexos = [] //considerando sempre que só existirá 1 anexo
        if(event.target.files){
            Array.from(event.target.files).map(arquivo => {
                this.listaAnexos.push({ file: arquivo, name: arquivo.name.replace(/[^a-zA-Z0-9\.]/g, "") })
            })
        }
    }

    removerAnexo = () => {
        this.listaAnexos = []
    }

    adicionarPlanilha = (event) => {
        this.loadingImport = true
        if(event.target.files){
            let arquivo = new FormData()
            arquivo.append("file",event.target.files[0])
            this.service.RecintoImportarXls(arquivo).then(response => {
                if(response && response.data) {
                    if(response.data.Sucesso){
                        this.listaImportacao = response.data.Lista
                        this.aviso = ""
                    }else{
                        this.aviso = response.data.MensagemErro
                    }
                }
            }).catch(err => console.log(err)
            ).finally(() => {this.loadingImport = false})
        }
    }

}


// WEBPACK FOOTER //
// ./src/modules/direcionamento/recinto/stores/NovoDirecionamentoStore.js